import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthorizationService } from '../service/authorization.service';

export const permissionGuard: CanActivateFn = async (route) => {
  const authorization = inject(AuthorizationService);
  const router = inject(Router);
  const permission = String(route.data?.['permission'] || '');
  const permissionsAny = Array.isArray(route.data?.['permissionsAny'])
    ? route.data?.['permissionsAny'].map((item: unknown) => String(item)) : [];
  if (!permission && !permissionsAny.length) return true;

  // Reutiliza imediatamente o contexto válido em memória/cache. A atualização
  // periódica com a API é feita em segundo plano pelo serviço de autorização.
  await authorization.load();
  const scope = route.data?.['permissionScope'] || 'app';
  const obraId = scope === 'obra'
    ? Number(route.paramMap.get('projeto_id') || route.queryParamMap.get('projeto_id') || route.queryParamMap.get('obra_id') || 0)
    : undefined;
  if (scope === 'obra' && !obraId) {
    return router.createUrlTree(['/dashboard'], {
      queryParams: { acesso_negado: 1 }
    });
  }
  const possuiPermissao = () => (permission && authorization.can(permission, obraId))
    || (permissionsAny.length && authorization.canAny(permissionsAny, obraId));
  if (possuiPermissao()) return true;

  // Uma permissão pode ter sido alterada por outro usuário ou dispositivo.
  // Antes de negar a rota, renova o contexto para não depender do cache local.
  await authorization.refresh(true);
  if (possuiPermissao()) return true;

  return router.createUrlTree(['/dashboard'], {
    queryParams: { acesso_negado: 1 }
  });
};
